"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformVehicleTypeToOfficialString = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const legacy_utils_1 = require("@daytrip/legacy-utils");
function getVehicleNameByTypeAndRoute(vehicleType, routeGeographyFlag) {
    if (!routeGeographyFlag) {
        return;
    }
    if (vehicleType === legacy_enums_1.VehicleType.LuxurySedan) {
        switch (true) {
            case (0, legacy_utils_1.isMexicanRoute)(routeGeographyFlag):
                return "Premium SUV";
            case (0, legacy_utils_1.isSuvReplacingLuxurySedanRoute)(routeGeographyFlag):
                return "SUV";
            case (0, legacy_utils_1.isCubaRoute)(routeGeographyFlag):
                return "Classic Cuban Car";
            default:
        }
    }
}
function transformVehicleTypeToOfficialString(vehicleType, routeGeographyFlag) {
    const specificVehicleNameByCountry = getVehicleNameByTypeAndRoute(vehicleType, routeGeographyFlag);
    if (specificVehicleNameByCountry) {
        return specificVehicleNameByCountry;
    }
    switch (vehicleType) {
        case legacy_enums_1.VehicleType.Sedan:
            return "Sedan";
        case legacy_enums_1.VehicleType.Mpv:
            return "MPV";
        case legacy_enums_1.VehicleType.Van:
            return "Van";
        case legacy_enums_1.VehicleType.Shuttle:
            return "Shuttle";
        case legacy_enums_1.VehicleType.LuxurySedan:
            return "Luxury Sedan";
        case legacy_enums_1.VehicleType.SedanLite:
            return "Sedan Lite";
        default:
            return "Unknown";
    }
}
exports.transformVehicleTypeToOfficialString = transformVehicleTypeToOfficialString;
//# sourceMappingURL=transformVehicleTypeToOfficialString.js.map